import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './searchsection.css';
import myImage from '../../../assets/images/Dashboard_Image.jpeg';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../registerflow/registerflow';

const Searchsection = ({ onSearchFocus }) => {
  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);
  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };
  const navigate = useNavigate();

  const navigateloginfn = () => {
    navigate("/login");
  }

  const handleRegisterClick = () => {
    setRegisterPopupVisible(true);
    // handleSidebarClose();
  };

  return (
    <div className='fluid-container'>
      <div className="searchbar-employer-wrapper">
        <div className="searchbar-employer-container">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            className="searchbar-input"
            placeholder="Search Director etc."
            onFocus={handleRegisterClick}
          // onFocus={onSearchFocus}
          />
          {/* <button className="search-button" onClick={onSearchFocus}> */}
          <button className="search-button" onClick={handleRegisterClick}>
            Search
          </button>
        </div>

        <div className="image-container">
          <img src={myImage} alt="Image of Dashboard" className="my-employer-image" />
        </div>
        <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
        <br></br>
      </div>
    </div>
  );
};

export default Searchsection;
